module.exports = __webpack_public_path__ + "img/clients_all.5d5cdbe8.svg";